import React from 'react';
import { Stack } from 'react-bootstrap';
import SelfPacedAnswerSelection from './self-paced-answer-selection';

function SelfPacedMultipleSelect({ question }) {
  return (
    <div className="w-100 pb-4">
      <Stack>
        <SelfPacedAnswerSelection question={question} />
      </Stack>
    </div>
  );
}

export default SelfPacedMultipleSelect;
